import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import * as serviceWorker from "src/serviceWorker";
import App from "src/App";
import "src/utils/i18n";
import "src/utils/Date";
import manifestDev from "src/manifest_dev.json";
import manifest from "src/manifest.json";
import { createRoot } from "react-dom/client";

const isLocalhost = window.location.host.indexOf("localhost") === 0;
const upperCaseSubdomain = () => {
    const subdomain = window.location.hostname?.split(".")[0];
    return `${subdomain[0].toUpperCase()}${subdomain.slice(1).toLowerCase()}`;
};

// Set design assets dynamically - localhost needs absolute URL to dev server
if (isLocalhost) {
    const baseUrl = "https://dev.wwportal.ch";

    // Set brand CSS
    const brandCssLink = document.getElementById("brand-css") as HTMLLinkElement;
    if (brandCssLink) {
        brandCssLink.href = `${baseUrl}/api/designs/css/brand.css`;
    }

    // Set favicon
    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (favicon) {
        favicon.href = `${baseUrl}/api/designs/favicon.png`;
    }

    // Set apple-touch-icons
    document.querySelectorAll("link[rel='apple-touch-icon']").forEach((link) => {
        const el = link as HTMLLinkElement;
        const size = el.getAttribute("sizes")?.split("x")[0];
        el.href = `${baseUrl}/api/designs/favicon.png?size=-rect${size}`;
    });
}

const manifestJSON = import.meta.env.VITE_ENVIRONMENT === "dev" ? manifestDev : manifest;
const name = isLocalhost ? "Localhost Portal" : `${upperCaseSubdomain()} Portal`;
manifestJSON.name = name;
manifestJSON.short_name = name;
const stringManifest = JSON.stringify(manifestJSON);
const blob = new Blob([stringManifest], { type: "application/json" });
const manifestURL = URL.createObjectURL(blob);
document?.querySelector("#my-manifest-placeholder")?.setAttribute("href", manifestURL);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);

serviceWorker.unregister();